export { MobileTabBar } from './MobileTabBar';
export type {
  LinkLike,
  MobileTabBarProps,
  MobileTabIcon,
  MobileTabItem,
  NavigatedMobileTabItem,
  PickedMobileTabItem,
} from './MobileTabBar.types';
